<script setup>
import { onMounted } from 'vue'
import { printResponseProperty, getPropertiesByValue } from '@/libs/utils/questions/radio_checkbox.js'

import QuestionGroupComponent from '@/components/DefaultVr/Components/QuestionGroupComponent.vue'

import TranslationProvider from '@/provider/translations.js'

const props = defineProps(['handleAnswer', 'compiledPoll', 'question']);
const answerValue = defineModel('answerValue')
const answerNote = defineModel('answerNote')

onMounted(()=>{
  answerValue.value = null
  props.compiledPoll['answers'].forEach((el) => {
    if (el['questionReference'] === props.question['reference']) {
      answerValue.value = el['value'];
      if(el['note']) {
        answerNote.value = el['note']
      }
    }
  });

  if (props.handleAnswer) {
    props.handleAnswer(props.question['reference'], answerValue.value, false, answerNote.value);
  }
});

function selectValueF() {
  if (props.handleAnswer !== null) {
    props.handleAnswer(props.question['reference'], answerValue.value, false, answerNote.value);
  }
}

function checkQuestionGroupDependentQuestionCondition(childQuestionGroup) {
  let condition = childQuestionGroup['dependentQuestionCondition'];
  let found = false;
  if (condition && condition === answerValue.value) {
    found = true;
  }

  if (!found) {
    resetAnswersChildQuestionGroup(childQuestionGroup)
  }
  return found;
}

function resetAnswersChildQuestionGroup(childQuestionGroup) {
  let questions = childQuestionGroup['questions'];
  questions.forEach((question, ) => {
    props.handleAnswer(question['reference'], null, true);
    if (question['childQuestionGroups'] && question['childQuestionGroups'].length > 0) {
      question['childQuestionGroups'].forEach((group, ) => {
        resetAnswersChildQuestionGroup(group);
      })
    }
  })
}

</script>

<template>
  <div>
    <label :for="'selectQuestion'+question['id']" :class="'form-label'+ (question.required ? ' fw-bold ' : '')">
      {{ question.text }} {{ question.required ? '*' : '' }}
    </label>

    <v-select
      v-model="answerValue"
      :options="question.additionalProperties.select_values"
      :required="question.required"
      :reduce="option => option.value"
      label="label"
      :name="question.id"
      :id="'selectQuestion' + question.id"
      :aria-label="question.text"
      :disabled="compiledPoll.state === 'filled' || handleAnswer === null"
      @update:modelValue="selectValueF"
      placeholder="Seleziona opzione"
    >
      <template v-slot:option="option">
        <span>
          {{option.label}}
        </span>

        <div v-if="option?.properties">
          <span v-for="(property, index) in option.properties"
                class="form-text"
          >
            <span v-if="printResponseProperty(property)">
              {{ printResponseProperty(property) }}
               <span v-if="index < option.properties.length - 1"> | </span>
            </span>
          </span>
        </div>
      </template>

      <template #no-options>
        <div class="form-text">
          {{TranslationProvider.getTrans('app.no_result_found')}}
        </div>
      </template>
    </v-select>

    <div v-if="answerValue" class="mb-3">
      <p v-for="prop in getPropertiesByValue(question.additionalProperties.select_values, answerValue)"
         class="mb-0 form-text"
      >
        {{ printResponseProperty(prop)}}
      </p>
    </div>

    <small v-if="question.helper" class="form-text">
      {{ question.helper }}
    </small>

    <div v-for="childQuestionGroup in question['childQuestionGroups']" :key="childQuestionGroup['id']">
      <div class="mt-2" v-if="checkQuestionGroupDependentQuestionCondition(childQuestionGroup)">
        <question-group-component :compiled-poll="compiledPoll" :handle-answer="handleAnswer" :question-group="childQuestionGroup"></question-group-component>
      </div>
    </div>

    <div v-if="question.hasNote" class="pt-2">
      <div class="pe-2">
        <label :for="'noteQuestion'+question['id']" class="form-label">Note</label>
        <textarea @change="selectValueF"
                  class="form-control" rows="2" placeholder="Inserisci note"
                  :id="'noteQuestion'+question['id']"
                  v-model="answerNote"
                  :disabled="!(compiledPoll['state'] !== 'filled' && handleAnswer !== null)"></textarea>
      </div>
    </div>
  </div>
</template>
